import type { AlertSeverity, AlertStatus } from '@/types/controlCenter'

import type { AlertColumnConfig } from './types'

// ── Page size ─────────────────────────────────────────────────────────────────

export const PAGE_SIZE = 10

// ── Severity ordering (lower = higher priority) ───────────────────────────────

export const SEVERITY_ORDER: Record<AlertSeverity, number> = {
  critical: 0,
  warning: 1,
  info: 2,
  success: 3,
}

// ── Severity badge styles ─────────────────────────────────────────────────────

export const SEVERITY_BADGE: Record<AlertSeverity, string> = {
  critical: 'bg-red-900/50 text-red-300 border border-red-800/60',
  warning: 'bg-amber-900/50 text-amber-300 border border-amber-800/60',
  success: 'bg-emerald-900/50 text-emerald-300 border border-emerald-800/60',
  info: 'bg-sky-900/50 text-sky-300 border border-sky-800/60',
}

// ── Status badge styles ───────────────────────────────────────────────────────

export const STATUS_BADGE: Record<AlertStatus, string> = {
  active: 'border border-emerald-500/40 bg-emerald-500/20 text-emerald-300',
  inactive: 'border border-border-main bg-neutral-dimmed text-text-tertiary',
}

export const STATUS_DOT: Record<AlertStatus, string> = {
  active: 'bg-emerald-400',
  inactive: 'bg-text-dimmed',
}

// ── Severity options (for filter dropdown) ────────────────────────────────────

export const SEVERITY_OPTIONS: AlertSeverity[] = [
  'critical',
  'warning',
  'info',
  'success',
]

// ── Column definitions ────────────────────────────────────────────────────────

export const COLUMN_CONFIG: AlertColumnConfig[] = [
  {
    key: 'name',
    label: 'Alert',
    sortable: true,
    className: 'w-[35%] max-w-[35%] min-w-[35%]',
  },
  { key: 'severity', label: 'Severity', sortable: true },
  {
    key: 'url',
    label: 'Path',
    sortable: true,
    className: 'w-[20%] max-w-[20%] min-w-[20%]',
  },
  { key: 'status', label: 'Status', sortable: true },
  { key: 'createdAt', label: 'Created', sortable: true },
  { key: 'endDate', label: 'Expiry', sortable: true },
  { key: 'actions', label: 'Actions', sortable: false },
]
